import { FC, Fragment } from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const NewConnectionExteriorTypesForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, submitChange } =
        useFormModel<ChangeNames.NEW_CONNECTION_EXTERIOR_TYPES>();

    const convertValue = (): string => {
        if (values.newConnectionExteriorTypes.value.connectionPillar) return "connectionPillar";
        if (values.newConnectionExteriorTypes.value.connectionPillarWithMeter) return "WithMeter";
        return "";
    };

    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Art des Außenanschlusses für Strom
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            const newValue = setValues((values) => {
                                values.newConnectionExteriorTypes.value = {
                                    connectionPillar: v.indexOf("connectionPillar") >= 0,
                                    connectionPillarWithMeter: v.indexOf("WithMeter") >= 0,
                                };
                            });
                            submitChange(newValue);
                        }}
                    >
                        <FormControlLabel
                            value="connectionPillar"
                            control={<Radio />}
                            label="Hausanschlusssäule"
                            text="Die Hausanschlusssäule beinhaltet nur den Netzanschluss."
                            error={values.newConnectionExteriorTypes.error !== null}
                        />
                        <FormControlLabel
                            value="WithMeter"
                            control={<Radio />}
                            label="Zähleranschlusssäule"
                            text="Die Zähleranschlusssäule beinhaltet neben dem Netzanschluss auch die Zähleranlage.<br />
                            Die Zähleranschlusssäule ist bauseits durch Ihren Elektroinstallateur zu beziehen."
                            error={values.newConnectionExteriorTypes.error !== null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
